import { Wrench } from "lucide-react";
import { gql, InternalSupportToolLogOrderByColumn } from "types";
import { FieldType, InternalResourceConfig } from "../lib/internal-resources";

const GET_SUPPORT_TOOL_LOG_LIST = gql(/* GraphQL */ `
  query InternalSupportToolLogList(
    $pagination: Pagination
    $filters: FiltersExpression
    $orderBy: InternalSupportToolLogOrderByInput
  ) {
    internalSupportToolLogList(
      pagination: $pagination
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      list {
        id
        action
        category
        userId
        user {
          id
          profile {
            name
          }
        }
        entityType
        entityId
        inputParams
        success
        errorMessage
        createdAt
      }
    }
  }
`);

export const supportToolLogResourceConfig: InternalResourceConfig = {
  resourceName: "support-tool-log",
  displayNameKey: "apps.admin.internalResources.supportToolLog.title",
  basePath: "/internal/data/support-tool-log",

  listQuery: GET_SUPPORT_TOOL_LOG_LIST,
  listQueryName: "internalSupportToolLogList",

  fields: [
    {
      key: "action",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.action",
      type: FieldType.String,
      sortKey: InternalSupportToolLogOrderByColumn.Action,
      width: 280,
    },
    {
      key: "category",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.category",
      type: FieldType.String,
      sortKey: InternalSupportToolLogOrderByColumn.Category,
      width: 120,
    },
    {
      key: "userId",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.user",
      type: FieldType.User,
      width: 200,
    },
    {
      key: "entityType",
      labelKey:
        "apps.admin.internalResources.supportToolLog.columns.entityType",
      type: FieldType.String,
      sortKey: InternalSupportToolLogOrderByColumn.EntityType,
      width: 130,
    },
    {
      key: "entityId",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.entityId",
      type: FieldType.Uuid,
      width: 150,
    },
    {
      key: "inputParams",
      labelKey:
        "apps.admin.internalResources.supportToolLog.columns.inputParams",
      type: FieldType.JSON,
      width: { min: 100, grow: 1 },
    },
    {
      key: "success",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.success",
      type: FieldType.Boolean,
      sortKey: InternalSupportToolLogOrderByColumn.Success,
      width: 100,
    },
    {
      key: "errorMessage",
      labelKey:
        "apps.admin.internalResources.supportToolLog.columns.errorMessage",
      type: FieldType.String,
      width: 250,
    },
    {
      key: "createdAt",
      labelKey: "apps.admin.internalResources.supportToolLog.columns.createdAt",
      type: FieldType.DateTime,
      sortKey: InternalSupportToolLogOrderByColumn.CreatedAt,
      width: 160,
    },
  ],

  list: {
    defaultSort: {
      column: InternalSupportToolLogOrderByColumn.CreatedAt,
      direction: "desc",
    },
    searchFields: [
      "support_tool_log.action",
      "support_tool_log.category",
      "support_tool_log.entity_type",
    ],
  },

  navigation: {
    icon: <Wrench size={16} />,
    order: 9,
  },
};
